import React, { Component } from "react";
import { useEffect, useState } from "react";

import { Bar } from "react-chartjs-2";
import ChartDataLabels from 'chartjs-plugin-datalabels';
import PropTypes from "prop-types";
import moment from "moment";

const BarChart = props => {
  // console.log(props);
  function numberFormat(number, digit = 2) {
    if (number === null || number === "null" || number === "") return "";
    function isFloat(n) {
      return Number(n) === n && n % 1 !== 0;
    }
    if (isFloat(number))
      return parseFloat(number.toFixed(digit)).toLocaleString(undefined, {
        minimumFractionDigits: digit,
      });
    return parseFloat(number).toLocaleString(undefined, {
      minimumFractionDigits: digit,
    });
  }
  const [dataGraph, setDataGraph] = useState({
    labels: ["1 ส.ค. 64", "2 ส.ค. 64", "3 ส.ค. 64", "4 ส.ค. 64", "5 ส.ค. 64", "6 ส.ค. 64", "7 ส.ค. 64", "8 ส.ค. 64", "9 ส.ค. 64", "10 ส.ค. 64", "11 ส.ค. 64", "12 ส.ค. 64", "13 ส.ค. 64"
      , "14 ส.ค. 64", "15 ส.ค. 64", "16 ส.ค. 64", "17 ส.ค. 64", "18 ส.ค. 64", "19 ส.ค. 64", "20 ส.ค. 64", "21 ส.ค. 64", "22 ส.ค. 64"],
    datasets: [
      {
        label: "Target",
        backgroundColor: "#B87EFF",
        borderColor: "#B87EFF",
        borderWidth: 1,
        hoverBackgroundColor: "#B87EFF",
        hoverBorderColor: "#B87EFF",
        data: [1666, 180, 944, 736, 240, 1271],
        type: 'line',
        showLine: false,
        pointStyle: 'dash',
        pointRotation: 90,
        pointBorderWidth: 100,
        hoverBorderWidth: 100,
        datalabels: {
          display: false,
          color: '#B87EFF',
          // position:'right',
          // textAlign:'right',
          // align:'start',
        }
      },
      {
        label: "Actual",
        backgroundColor: "#595CFC",
        borderColor: "#7AE3F7",
        borderWidth: 1,
        hoverBackgroundColor: "#8386FE",
        hoverBorderColor: "#7AE3F7",
        data: [350, 350, 330, 340, 310, 305, 320, 330, 390, 330, 320, 350, 350, 370, 350, 330, 270, 270, 270, 280, 280, 285,],
        datalabels: {
          color: '#51E7FE'
        }
      },
    ],
  });

  const [option, setOption] = useState({
    // maintainAspectRatio: true,
    plugins: {
      datalabels: {
        align: 'top',
      },
    },
    // layout: {
    //   padding: {
    //     right: 15
    //   }
    // },
    scales: {
      dataset: [
        {
          barPercentage: 0.4,
        },
      ],
      xAxes: [{
        display: true,
        scaleLabel: {
          display: true,
          fontSize: 12,
          labelString: 'Date',
          fontColor: "#FFFFFF",
        },
        // gridLines: {
        //   display: true,
        // },
        ticks: {
          fontColor: "#FFFFFF", // this here
        },
      }],
      yAxes: [{
        display: true,
        scaleLabel: {
          display: true,
          fontSize: 12,
          labelString: 'MMscf/BBTU',
          fontColor: "#FFFFFF",
          position: 'left',
        },
        // gridLines: {
        //   display: true,
        // },
        ticks: {
          fontColor: "#FFFFFF", // this here
          // max:0,
          // min:0,
          callback: function (label, index, labels) {
            var val = Math.abs(label);
            // if (val >= 1000) {
            //   if (label < 0) {
            //     val = val * -1;
            //   }
            //   val = numberFormat(val / 1000, 1) + " K";
            // } else {
              if (label < 0) {
                val = val * -1;
              }
              val = numberFormat(val, 0);
            // }
            return val;
          },
          beginAtZero: true,
        },
      }],
    },
    tooltips: {
      enabled: true,
      mode: 'nearest',
      intersect: false,
      callbacks: {
        label: function (tooltipItem, data) {
          // console.log(tooltipItem);
          // console.log(data);
          // var indice = tooltipItem.index;
          return numberFormat(tooltipItem.yLabel, 2);
        }
      },
    },
    legend: {
      labels: {
        generateLabels: chart => chart.data.datasets.map((dataset, i) => ({
          datasetIndex: i,
          text: dataset.label,
          fillStyle: dataset.backgroundColor,
          strokeStyle: dataset.borderColor
        })),
        fontColor: "#FFFFFF",
      },
    },
  });


  useEffect(() => {
    renderGraph();
    // console.log(props.data);
  }, [props.data, props.date, props.summaryReportPid, props.targetPlan]);

  const renderGraph = () => {

    let dataSort = props.data.sort(function (a, b) {
      return moment(a.REPORT_DATE).toDate() - moment(b.REPORT_DATE).toDate();
    });

    let dataDateTarget = props.targetPlan.sort(function (a, b) {
      return moment(a.DAILYFLOWPLAN_DATE).toDate() - moment(b.DAILYFLOWPLAN_DATE).toDate();
    });

    let dateList = [moment(props.date).locale("en").format("D MMM")];

    for (let index = 0; index < 29; index++) {
      dateList.unshift(
        moment(props.date)
          .add("days", -(index + 1))
          .locale("en")
          .format("D MMM")
      );
    }

    let dataTarget = [];
    let dataGenGraph = [];
    dateList.map(item => {
      let data = dataSort.find(row => {
        // console.log(row, item);
        if (item == moment(props.date).locale("en").format("D MMM")) {
          // console.log(row);
          return (
            moment(row.REPORT_DATE).locale("en").format("D MMM") == item &&
            props.summaryReportPid == row.SUMMARYREPORT_PID
          );
        }
        return (
          moment(row.REPORT_DATE).locale("en").format("D MMM") == item
        );
      });

      let resData = dataDateTarget.find(row => {
        // console.log(row, item);
        if (item == moment(props.date).locale("en").format("D MMM")) {
          // console.log(row);
          return (
            moment(row.DAILYFLOWPLAN_DATE).locale("en").format("D MMM") == item
            // &&
            // props.summaryReportPid == row.SUMMARYREPORT_PID
          );
        }
        return (
          moment(row.DAILYFLOWPLAN_DATE).locale("en").format("D MMM") == item
        );
      });

      if (data == undefined) {
        dataGenGraph.push(null);
      } else {
        dataGenGraph.push(data?.FUEL_ACTUAL);
      }

      if (resData == undefined) {
        dataTarget.push(null);
      } else {
        dataTarget.push(resData?.DAILYFLOWPLAN_DATA);
      }

    });

    // ของเดิม
    // let data = props.data.sort(function (a, b) {
    //   return moment(a.REPORT_DATE).toDate() - moment(b.REPORT_DATE).toDate();
    // });

    // let dataList = [...data.map(obj => obj.FUEL_ACTUAL)]; //SUM_FUEL

    // let dateList = [
    //   ...data.map(obj =>
    //     moment(obj.REPORT_DATE).locale("en").format("D MMM YYYY")
    //   ),
    // ];
    // ของเดิม


    // let dataList = [
    //   ...props.data.sort(function (a, b) {
    //     return (
    //       moment(b.REPORT_DATE).toDate() - moment(a.REPORT_DATE).toDate()
    //     );
    //   }).map((obj) => obj.BALANCING_BALANCE)
    // ];

    // let dateList = [moment(props.date).locale("en").format("D MMM YYYY")];

    // let countData = props.data.length;

    // for (let index = 0; index < countData -1; index++) {
    //   // maxList.push(min);
    //   // minList.push(max);
    //   dateList.unshift(
    //     moment(props.date)
    //       .add("days", -(index + 1))
    //       .locale("en")
    //       .format("D MMM YYYY")
    //   );

    // }

    setDataGraph({
      labels: dateList,
      datasets: [
        {
          label: "Target",
          backgroundColor: "#FF4545",
          borderColor: "#FF4545",
          borderWidth: 3,
          hoverBackgroundColor: "#FF4545",
          hoverBorderColor: "#FF4545",
          data: dataTarget,
          type: 'line',
          showLine: true,
          fill: false,
          tension: 0,
          spanGaps: false,
          pointStyle: 'dash',
          borderDashOffset: 0.5,
          borderDash: [8, 8],
          pointRotation: 50,
          pointBorderWidth: 0.1,
          hoverBorderWidth: 1,
          datalabels: {
            display: false,
            // color: '#FF4545',
            // anchor: "start",
            // align: "right",
            // offset: 5,
            // rotation: -25,
            // formatter: function (value, context) {
            //   if (value == 0) {
            //     return "";
            //   }
            //   return numberFormat(value, 2);
            // }
          }

          //ของเดิม
          // pointStyle: 'dash',
          // pointRotation: 90,
          // pointBorderWidth: 35,
          // hoverBorderWidth: 50,
          // color: "#FFFFFF",
          // datalabels: {
          //   color: '#F8F3AC',
          //   anchor: "start",
          //   align: "right",
          //   offset: 15,
          //   rotation: -25,
          //   formatter: function (value, context) {
          //     if (value == 0) {
          //       return "";
          //     }
          //     return numberFormat(value, 2);
          //   }
          // }
        },
        {
          label: "Actual",
          backgroundColor: "#437AD5",
          borderColor: "#437AD5",
          borderWidth: 2,
          barPercentage: 0.9,
          hoverBackgroundColor: "#437AD5",
          hoverBorderColor: "#FFFFFF",
          data: dataGenGraph,
          type: 'bar',
          color: "#FFFFFF",
          datalabels: {
            color: '#A9C7F9',
            anchor: "end",
            align: "top",
            offset: 0,
            formatter: function (value, context) {
              if (value == 0) {
                return "";
              }
              return numberFormat(value, 2);
            }
          }
        },
      ],
    });
  };

  return (
    <React.Fragment>
      <Bar width={500} height={300} data={dataGraph} options={option} />
      {/* plugins={[ChartDataLabels]}   */}
    </React.Fragment>
  );
};

BarChart.propTypes = {
  t: PropTypes.any,
  data: PropTypes.any,
  date: PropTypes.any,
  summaryReportPid: PropTypes.any,
  targetPlan: PropTypes.any,
};
export default BarChart;

// class BarChart extends Component {
//   render() {
//     const data = {
//       labels: ["1 ส.ค. 64", "2 ส.ค. 64", "3 ส.ค. 64", "4 ส.ค. 64", "5 ส.ค. 64", "6 ส.ค. 64", "7 ส.ค. 64", "8 ส.ค. 64", "9 ส.ค. 64", "10 ส.ค. 64", "11 ส.ค. 64", "12 ส.ค. 64", "13 ส.ค. 64"
//         , "14 ส.ค. 64", "15 ส.ค. 64", "16 ส.ค. 64", "17 ส.ค. 64", "18 ส.ค. 64", "19 ส.ค. 64", "20 ส.ค. 64", "21 ส.ค. 64", "22 ส.ค. 64"],
//       datasets: [
//         {
//           label: "Actual",
//           backgroundColor: "#595CFC",
//           borderColor: "#7AE3F7",
//           borderWidth: 1,
//           hoverBackgroundColor: "#8386FE",
//           hoverBorderColor: "#7AE3F7",
//           data: [350, 350, 330, 340, 310, 305, 320, 330, 390, 330, 320, 350, 350, 370, 350, 330, 270, 270, 270, 280, 280, 285,],
//         },
//       ],
//     }

//     const option = {
//       scales: {
//         dataset: [
//           {
//             barPercentage: 0.4,
//           },
//         ],
//       },

//     }

//     return (
//       <React.Fragment>
//         <Bar width={500} height={300} data={data} options={option} />
//       </React.Fragment>
//     )
//   }
// };